import {
  FINGERPRINTING_CONFIG_LOADED,
  FINGERPRINTING_CONFIG_CLEAR,
} from '../../actions/actionTypes';

const initialState = {
  fingerprintingConfig: null,
};

const fingerprinting = (state = initialState, action) => {
  switch (action.type) {
    case FINGERPRINTING_CONFIG_LOADED:
      return {
        ...state,
        fingerprintingConfig: action.payload.config,
      };

    case FINGERPRINTING_CONFIG_CLEAR:
      return {
        ...state,
        fingerprintingConfig: null,
      };

    default:
      return state;
  }
};

export default fingerprinting;
